/**
 * 前支持的参数清单如下：
注意：如果您想要回传价值信息，您需要回传value和currency两个必要参数（目前支持的currency值：BRL、IDR、USD）参数名	描述	必选或可选	值类型
content_type	content_type对象属性值须设为product或product_group，具体取决于设置产品目录时对数据feed进行的配置。如果要监测与单个产品相关的事件，请将值设置为product。如果要监测与产品组相关的事件，请将其设置为product_group。	可选	必须是product或product_group。
contents	当有多个内容ID时，请使用contents。如果在参数中使用contents，则必须在子对象中包括以下内容：产品ID，以及数量（添加到购物车或购买的物品数量）。	DPA需要contents或content_id	必须是对象数组（内容参数、id子对象和数量子对象）。
content_id*	产品或内容的标识符	DPA需要contents或content_id	字符串
content_category	页面/产品的类别	可选	字符串
content_name	页面/产品的名称	可选	字符串
currency	指在社会和经济活动中作为流通手段使用的货币，例如美元
根据https://en.wikipedia.org/wiki/ISO_4217，该值应为大写英文字母表示，例如"USD"、"BRL"、"IDN"	可选，针对电商客户则建议包括	枚举（字符串）
value	订单总价，例如10.13	可选，针对电商客户则建议包括	数字
quantity*	用户添加到购物车或购买的产品数量	可选	数字
price*	商品价格，单位为元，例如4.99	可选	数字
query	与搜索事件一起使用。用户输入的搜索字符串。	可选	字符串
mapping_id	用于帮助全渠道数据优化模型标识用户	可选，请联系您的CST协助开启	字符串
 */

import { getSiteConfiguration } from "@/src/utils/configUtils";

// 快手pixel事件参数
interface KwaiPixelEventParams {
    content_type?: "product" | "product_group";
    contents?: Array<{
        content_id: string;
        quantity: number;
        price?: number;
        content_name?: string;
    }>;
    content_id?: string;
    content_category?: string;
    content_name?: string;
    currency?: string;
    value?: number;
    quantity?: number;
    price?: number;
    query?: string;
    mapping_id?: string;

    items?: Array<{
        item_id: string;
        item_name: string;
        price: number;
        quantity: number;
    }>;
}

async function isKwaiqLoaded() {
    let timer: NodeJS.Timeout;
    let attempts = 0;
    const maxAttempts = 200; // 10 seconds / 50ms = 200 attempts
    return new Promise((rev, rej) => {
        if (window && window.kwaiq) {
            rev(true);
        } else {
            timer = setInterval(() => {
                attempts++;
                if (window && window.kwaiq) {
                    rev(true);
                    clearInterval(timer);
                } else if (attempts >= maxAttempts) {
                    rej(false);
                    console.log("kwaiq not loaded");
                    clearInterval(timer);
                }
            }, 50);
        }
    });
}

// 快手pixel
class KwaiPixel {
    pixelId: string;
    constructor() {
        this.pixelId = "";
    }

    // 初始化
    init(domain: string) {
        const KwaiPixelCODE = getSiteConfiguration("KwaiPixelCODE", domain);
        if (!KwaiPixelCODE) return;
        this.pixelId = KwaiPixelCODE;
        const head = document.getElementsByTagName("HEAD").item(0);
        const label = document.createElement("script");
        label.type = "text/javascript";
        label.innerHTML = `
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";var o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var o,r=0,i=t.length;r<i;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t,n){var o,i=e.createElement("script");i.type="text/javascript",i.async=!0,i.src=t,n&&(i.onerror=function(){r(e,n)});var a=e.getElementsByTagName("script")[0];null===(o=a.parentNode)||void 0===o||o.insertBefore(i,a)};!function(e,t,n){e.KwaiAnalyticsObject=n;var i=e[n]=e[n]||[];i.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];var a=function(e,t){e[t]=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];var i=o([t],n,!0);e.push(i)}};i.methods.forEach((function(e){a(i,e)})),i.instance=function(e){var t,n=(null===(t=i._i)||void 0===t?void 0:t[e])||[];return i.methods.forEach((function(e){a(n,e)})),n},i.load=function(e,o){var a="https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js";i._i=i._i||{},i._i[e]=[],i._i[e]._u=a,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=o||{};var c="?sdkid=".concat(e,"&lib=").concat(n);r(t,a+c,"https://s16-11187.ap4r.com/kos/s101/nlav11187/pixel/events.js"+c)}}(window,document,"kwaiq")}])}));
kwaiq.load('${KwaiPixelCODE}');
kwaiq.page();
    `;
        if (head) {
            head.appendChild(label);
        }
    }

    // 跟踪事件
    track(event: string, params?: KwaiPixelEventParams) {
        if (!this.pixelId) return;
        isKwaiqLoaded().then((res) => {
            if (res) {
                console.log("isKwaiqLoaded", this.pixelId, event, params);
                window.kwaiq.instance(this.pixelId).track(event, params);
            }
        });
    }

    // 加购
    addToCart(params: KwaiPixelEventParams) {
        this.track("addToCart", params);
    }

    // 用户点击商品进入详情页或点击试戴按钮
    buttonClick(params: KwaiPixelEventParams) {
        this.track("buttonClick", params);
    }

    // 完成付款
    purchase(params: KwaiPixelEventParams) {
        this.track("purchase", params);
    }

    // 内容被查看
    contentView(params: KwaiPixelEventParams) {
        this.track("contentView", params);
    }

    // 结账流程开始
    initiatedCheckout(params: KwaiPixelEventParams) {
        this.track("initiatedCheckout", params);
    }

    // 注册完成
    completeRegistration(params?: KwaiPixelEventParams) {
        this.track("completeRegistration", params);
    }
}

const Kwai = new KwaiPixel();

export default Kwai;
